<template>
    <div>
        <common-buttons v-if="!referralOverviewRequested">
            <common-button
                :label="$t('pages.referrals.reports.buttons.referral_overview')"
                type="primary"
                size="large"
                @click="generateReferralOverview()"
            ></common-button>
        </common-buttons>
        <template v-else>
            <div class="header-row">
                <div class="header-row__left-section">
                    <div class="header-row__title">
                        <h2>{{ $t('common.referrals_overview.title') }}</h2>
                    </div>
                </div>
                <div class="header-row__period-selection">
                    <form-wrapper>
                        <form-row>
                            <form-cell>
                                <date-range-field
                                    :formData="data"
                                    openSide="left"
                                    valuePath="dateRange"
                                    @change="dateRangeChange($event)"
                                ></date-range-field>
                            </form-cell>
                        </form-row>
                    </form-wrapper>
                </div>
            </div>
            <template v-if="isLoading">
                <div class="loading-spinner">
                    <span>Loading</span>
                    <common-logo-spinner :width="56"></common-logo-spinner>
                </div>
            </template>
            <template v-else>
                <div v-if="!reportData" class="no-analytic-data">
                    {{ $t(`pages.referrals.reports.error`) }}
                </div>
                <div v-else>
                    <div class="upper-analytics-overview">
                        <common-tabs :tabs="tabs" :activeTab="tabs[0].name" class="tab-content-heightend">
                            <template v-slot:received>
                                <upper-report-overview
                                    key="received"
                                    referralType="received"
                                    :referralData="reportData"
                                ></upper-report-overview>
                            </template>
                            <template v-slot:made>
                                <upper-report-overview
                                    key="made"
                                    referralType="made"
                                    :referralData="reportData"
                                ></upper-report-overview>
                            </template>
                        </common-tabs>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    import dayjs from 'dayjs'

    import FormMixin from 'mixins/FormMixin'
    import UpperReportOverview from 'components/page-elements/referrals-overview/UpperReportOverview'
    import ReferralsAPI from 'api/ReferralsAPI'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    const DATE_FORMAT = 'YYYY-MM-DD'

    export default {
        mixins: [FormMixin, ScreenSizeDetectionMixin],
        components: {
            UpperReportOverview,
        },
        data() {
            return {
                referralOverviewRequested: false,
                tabs: [
                    {
                        name: 'received',
                    },
                    {
                        name: 'made',
                    },
                ].map((tab) => {
                    tab.displayName = this.$t(`pages.referrals.reports.tabs.${tab.name}`)
                    return tab
                }),
                reportData: null,
                isLoading: false,
            }
        },
        computed: {
            isAllowedToGenerateReferralOverview() {
                return this.$auth.getActiveMember().isMasterUser
            },
        },
        methods: {
            generateReferralOverview() {
                this.referralOverviewRequested = true
            },
            loadReportData() {
                this.isLoading = true
                ReferralsAPI.getAnalyticReportData(
                    this.$auth.getActiveMember().id,
                    dayjs(this.data.dateRange.startDate).format(DATE_FORMAT),
                    dayjs(this.data.dateRange.endDate).format(DATE_FORMAT),
                )
                    .then((response) => {
                        this.reportData = response
                    })
                    .catch(() => {
                        this.reportData = null
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
            dateRangeChange(event) {
                this.change(event)
                this.loadReportData()
            },
        },
        watch: {
            referralOverviewRequested() {
                if (this.referralOverviewRequested) {
                    this.loadReportData()
                }
            },
        },
        created() {
            const currentDateTime = new Date()
            const oneMonthAgo = new Date()
            oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1)
            this.data.dateRange = {
                startDate: oneMonthAgo,
                endDate: currentDateTime,
            }
        },
    }
</script>

<style lang="scss" scoped>
    .header-row {
        display: flex;

        &__left-section {
            flex-grow: 1;
        }
    }

    .loading-spinner {
        text-align: center;
        font-size: 16px;
    }

    .no-analytic-data {
        text-align: center;
        font-size: 16px;
    }
    .tab-content-heightend {
        height: 950px;
    }
</style>
